// const wheight = window.innerHeight;

const styles = {
  appContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
  },
  scrollableWrapper: {
    flex: 1,
    overflow: 'hidden',
    borderLeft: '1px solid #1A192B',
    borderRight: '1px solid #1A192B',
    borderBottom: '1px solid #1A192B',
  },
  reactFlowNodeGroup: {
    borderRadius: 0,
  },
  rfStyle: {
    width: '100%',
    height: '100%',
    backgroundColor: '#fff',
  },
  searchInput: {
    borderWidth: 1,
    borderColor: '#002060',
    borderRadius: 0,
    padding: 9,
    marginBottom: 10,
    width: '100%',
  },
};

export default styles;
